
import AdminManagement from "../../Screens/AdminManagement";
import CreateAdmin from "../../Screens/AdminManagement/CreateAdmin";
import NeighborhoodManagement from "../../Screens/NeighborhoodManagement";
import CreateNeighborhood from "../../Screens/NeighborhoodManagement/CreateNeighborhood";
import NeighborhoodDetails from "../../Screens/NeighborhoodManagement/NeighborhoodDetails";
import VendorAds from "../../Screens/VendorAds";
import ForgetPassword from "../../Screens/Auth/ForgetPassword";
import ForgetPassword2 from "../../Screens/Auth/ForgetPassword2";
import ForgetPassword3 from "../../Screens/Auth/ForgetPassword3";
import AdminLogin from "../../Screens/Auth/Login";
import { Banner } from "../../Screens/Banner";
import AddBanner from "../../Screens/Banner/AddBanner";
import { Brands } from "../../Screens/Brands";
import AddBrand from "../../Screens/Brands/AddBrand";
import EditBrand from "../../Screens/Brands/EditBrand";
import { Category } from "../../Screens/Category";
import AddCategory from "../../Screens/Category/AddCategory";
import CategoryDetails from "../../Screens/Category/CategoryDetails";
import EditCategory from "../../Screens/Category/EditCategory";
import ContractMessages from "../../Screens/ContractMessages";
import Messages from "../../Screens/ContractMessages/messages";
import { Customers } from "../../Screens/Customers";
import CustomerDetails from "../../Screens/Customers/CustomerDetails";
import Error from "../../Screens/Error";
import Guidelines from "../../Screens/Guidelines";
import Notifications from "../../Screens/Notifications";
import { Orders } from "../../Screens/Orders";
import OrderDetails from "../../Screens/Orders/OrderDetails";
import PaymentLogs from "../../Screens/PaymentLogs";
import { Products } from "../../Screens/Products";
import AddProduct from "../../Screens/Products/AddProduct";
import EditProduct from "../../Screens/Products/EditProduct";
import ProductDetails from "../../Screens/Products/ProductDetails";
import Profile from "../../Screens/Profile";
import ChangePassword from "../../Screens/Profile/ChangePassword";
import EditProfile from "../../Screens/Profile/EditProfile";
import PromoCodes from "../../Screens/PromoCodes";
import PushNotifications from "../../Screens/PushNotifications";
import RaiseIssue from "../../Screens/RaiseIssue";
import Chatroom from "../../Screens/RaiseIssue/Chatroom";
import RefundRequests from "../../Screens/RefundRequests";
import AddRepresentative from "../../Screens/Representatives/AddRepresentative";
import { Representatives } from "../../Screens/Representatives/index";
import RepresentativeDetails from "../../Screens/Representatives/RepresentativeDetails";
import Reviews from "../../Screens/Reviews";
import Services from "../../Screens/Services";
import Statistics from "../../Screens/Statistics";
import Subscriptions from "../../Screens/Subscriptions";
import { UserRequests } from "../../Screens/UserRequests";
import UserRequestDetails from "../../Screens/UserRequests/UserRequestDetails";
import WithdrawlRequests from "../../Screens/WithdrawlRequests";
import { ResidentApprovals } from "../../Screens/ResidentApprovals";
import { ReviewApprovals } from "../../Screens/ReviewApprovals";
import AdPricing from "../../Screens/AdPricing";
import FamilyManagement from "../../Screens/FamilyManagement";
import CreateFamilyLink from "../../Screens/FamilyManagement/CreateFamilyLink";
import FamilyLinkDetails from "../../Screens/FamilyManagement/FamilyLinkDetails";
import LocationHistory from "../../Screens/FamilyManagement/LocationHistory";
import PathEditor from "../../Screens/PathEditor";
import LandmarkManager from "../../Screens/LandmarkManager";
import RouteTester from "../../Screens/RouteTester";
import Rangefinder from "../../Screens/Rangefinder";

let AppRoutes = [
  {
    path: "/",
    element: <UserRequests />,
    isProtected: true
  },
  {
    path: "/login",
    element: <AdminLogin />
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />
  },
  {
    path: "/forget-password2",
    element: <ForgetPassword2 />
  },
  {
    path: "/forget-password3",
    element: <ForgetPassword3 />
  },
  // {
  //     path: "/dashboard",
  //     element: <Dashboard />,
  //     isProtected: true
  // },
  {
    path: "/vendor-requests",
    element: <UserRequests />,
    isProtected: true
  },
  {
    path: "/vendor-requests/:id",
    element: <UserRequestDetails />,
    isProtected: true
  },
  {
    path: "/resident-approvals",
    element: <ResidentApprovals />,
    isProtected: true
  },
  {
    path: "/review-approvals",
    element: <ReviewApprovals />,
    isProtected: true
  },
  {
    path: "/vendor-ads",
    element: <VendorAds />,
    isProtected: true
  },
  {
    path: "/ad-pricing",
    element: <AdPricing />,
    isProtected: true
  },
  {
    path: "/profiles",
    element: <Representatives />,
    isProtected: true
  },
  {
    path: "/add-representative",
    element: <AddRepresentative />,
    isProtected: true
  },
  {
    path: "/profiles/:id",
    element: <RepresentativeDetails />,
    isProtected: true
  },
  {
    path: "/brands",
    element: <Brands />,
    isProtected: true
  },
  {
    path: "/add-brand",
    element: <AddBrand />,
    isProtected: true
  },
  {
    path: "/edit-brand/:id",
    element: <EditBrand />,
    isProtected: true
  },
  {
    path: "/categories",
    element: <Category />,
    isProtected: true
  },
  {
    path: "/categories/:id",
    element: <CategoryDetails />,
    isProtected: true
  },
  {
    path: "/categories/add",
    element: <AddCategory />,
    isProtected: true
  },
  {
    path: `/edit-category/:id`,
    element: <EditCategory />,
    isProtected: true
  },
  {
    path: "/products",
    element: <Products />,
    isProtected: true
  },
  {
    path: "/contract-messages",
    element: <ContractMessages />,
    isProtected: true
  },
  {
    path: "/contract-messages/:id",
    element: <Messages />,
    isProtected: true
  },
  {
    path: "/withdrawl-requests",
    element: <WithdrawlRequests />,
    isProtected: true
  },
  {
    path: "/refund-requests",
    element: <RefundRequests />,
    isProtected: true
  },
  {
    path: "/raise-issues",
    element: <RaiseIssue />,
    isProtected: true
  },
  {
    path: "/raise-issues/:id",
    element: <Chatroom />,
    isProtected: true
  },
  {
    path: "/products/:id",
    element: <ProductDetails />,
    isProtected: true
  },
  {
    path: "/edit-product/:id",
    element: <EditProduct />,
    isProtected: true
  },
  {
    path: "/banner",
    element: <Banner />,
    isProtected: true
  },
  {
    path: "/add-banner",
    element: <AddBanner />,
    isProtected: true
  },
  {
    path: "/orders",
    element: <Orders />,
    isProtected: true
  },
  {
    path: "/orders/:id",
    element: <OrderDetails />,
    isProtected: true
  },
  {
    path: "/add-product",
    element: <AddProduct />,
    isProtected: true
  },
  {
    path: "/profile",
    element: <Profile />,
    isProtected: true
  },
  {
    path: "/profile/edit-profile",
    element: <EditProfile />,
    isProtected: true
  },
  {
    path: "/profile/change-password",
    element: <ChangePassword />,
    isProtected: true
  },
  {
    path: "/notifications",
    element: <Notifications />,
    isProtected: true
  },
  {
    path: "/representative/customers",
    element: <Customers />,
    isProtected: true
  },
  {
    path: "/representative/customers/details/:id",
    element: <CustomerDetails />,
    isProtected: true
  },
  {
    path: "/representative/orders/:id",
    element: <OrderDetails />,
    isProtected: true
  },
  {
    path: "/guidelines",
    element: <Guidelines />,
    isProtected: true
  },
  {
    path: "/admin-management",
    element: <AdminManagement />,
    isProtected: true
  },
  {
    path: "/admins",
    element: <AdminManagement />,
    isProtected: true
  },
  {
    path: "/admins/create",
    element: <CreateAdmin />,
    isProtected: true
  },
  {
    path: "/neighborhoods",
    element: <NeighborhoodManagement />,
    isProtected: true
  },
  {
    path: "/neighborhoods/create",
    element: <CreateNeighborhood />,
    isProtected: true
  },
  {
    path: "/neighborhoods/view/:id",
    element: <NeighborhoodDetails />,
    isProtected: true
  },
  {
    path: "/promo-codes",
    element: <PromoCodes />,
    isProtected: true
  },
  {
    path: "/services",
    element: <Services />,
    isProtected: true
  },
  {
    path: "/payment-logs",
    element: <PaymentLogs />,
    isProtected: true
  },
  {
    path: "/push-notifications",
    element: <PushNotifications />,
    isProtected: true
  },
  {
    path: "/reviews",
    element: <Reviews />,
    isProtected: true
  },
  {
    path: "/statistics",
    element: <Statistics />,
    isProtected: true
  },
  {
    path: "/family-management",
    element: <FamilyManagement />,
    isProtected: true
  },
  {
    path: "/family-management/create",
    element: <CreateFamilyLink />,
    isProtected: true
  },
  {
    path: "/family-management/details/:id",
    element: <FamilyLinkDetails />,
    isProtected: true
  },
  {
    path: "/family-management/location/:id",
    element: <LocationHistory />,
    isProtected: true
  },
  {
    path: "/rangefinder",
    element: <Rangefinder />,
    isProtected: true
  },
  {
    path: "/rangefinder/path-editor",
    element: <PathEditor />,
    isProtected: true
  },
  {
    path: "/rangefinder/landmark-manager",
    element: <LandmarkManager />,
    isProtected: true
  },
  {
    path: "/rangefinder/route-tester",
    element: <RouteTester />,
    isProtected: true
  },
  {
    path: "*",
    element: <Error />
  }
]

export default AppRoutes
